import { createContext } from 'react';

export const PlotContext = createContext({});
